import React from 'react';
import { useSelector } from 'react-redux';
import cN from 'classnames';
import { RootState } from '@Redux/detail/store';
import { LightBox } from '@lion-design/core';
import styles from './styles.module.scss';
import Title from './subComponents/Title';
import TodayMoreGroupList from './subComponents/TodayMoreGroupList';

interface I_Props {
    open: boolean;
    ToggleLightBox: () => void;
    storyData?: {
        url: string;
    };
}

const GroupAllDetailMore: React.FC<I_Props> = ({ open, ToggleLightBox }) => {
    const { todayMore } = useSelector((state: RootState) => state.groupReducer);

    return (
        <LightBox
            open={open}
            ToggleLightBox={ToggleLightBox}
            className={cN(styles.container, 'group_detail_more')}
        >
            <Title />
            <TodayMoreGroupList
                todayMoreList={todayMore?.GroupList}
                NormGroupID={todayMore?.NormGroupID}
                triggerLightBox={ToggleLightBox}
            />
        </LightBox>
    );
};

export default GroupAllDetailMore;
